import Box from '@mui/material/Box';

/**
 * Boolean flag pill — "Sim"/"Não" — DESIGN-SYSTEM.md §2 pill anatomy, but the
 * `no-dot` variant (no leading dot/icon), used for boolean columns/fields
 * throughout the app: `pill.blue.no-dot` / `pill.grey.no-dot` in
 * `prototipo-importar-produtos.html`, first adopted in the app by
 * `pages/services/List.js`/`View.js` ("Serviço externo").
 *
 * Distinct from `StatusChip` (§4 domain/value/color lookup, always renders a
 * dot or icon) — this is a plain two-value flag, not a semantic status.
 *
 * @param {boolean} value
 * @param {string} [trueLabel='Sim']
 * @param {string} [falseLabel='Não']
 */
export default function BooleanPill({ value, trueLabel = 'Sim', falseLabel = 'Não', sx }) {
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                fontSize: '11px',
                fontWeight: 700,
                lineHeight: 1,
                padding: '4px 10px',
                borderRadius: '20px',
                bgcolor: value ? 'info.bg' : 'background.subtle',
                color: value ? 'primary.main' : 'text.disabled',
                ...sx,
            }}
        >
            {value ? trueLabel : falseLabel}
        </Box>
    );
}
